  
import Logger from '../helpers/logger';

const log = new Logger();
  
export default ['$http', function BigQueryService($http) {
  /**
   * Send V1 info to warehouse
   *
   * @param response
   * @returns Promise
   */
  this.sendV1MrktBQTrialCreate = (response) => {
    log.debug({
      category: 'thirdParty',
      message: 'sendV1MrktBQTrialCreate'
    });

    const d = this.buildV1MrktBQTrialCreate(response);

    return $http.post(process.env.TRIALS.V1_BQ_CREATE_URL, d);
  };

  this.buildV1MrktBQTrialCreate = (response) => {
    const fields = {
      campaign: 'campaign',
      country: 'country',
      customerId: 'customerId',
      deviceType: 'deviceType',
      emailAddress: 'email',
      firstName: 'firstName',
      gaClientID: 'gaClientId',
      Geo_City__c: 'geo_city',
      Geo_Continent__c: 'geo_continent',
      Geo_Country__c: 'geo_country',
      Geo_Ip__c: 'geo_ip',
      Geo_Latitude__c: 'geo_latitude',
      Geo_Longitude__c: 'geo_longitude',
      Geo_Postal_Code__c: 'geo_postalCode',
      Geo_State__c: 'geo_state',
      Geo_Time_Zone__c: 'geo_timeZone',
      keyword: 'keyword',
      landingpage: 'landingPage',
      lastName: 'lastName',
      leadDescription: 'leadDescription',
      leadSource: 'leadSource',
      leadTimeSent: 'leadTimeSent',
      medium: 'medium',
      optimizely: 'optimizely',
      phoneNumber: 'phone',
      referrer: 'referrer',
      SMSOptIn: 'SMSOptIn',
      source: 'source',
      storeUrl: 'storeUrl',
      version: 'version'
    };

    const BQData = {};

    Object.keys(response).forEach((key) => {
      if (fields[key] === undefined) {
        return;
      }

      if (Array.isArray(fields[key])) {

        fields[key].forEach((k) => {
          BQData[k] = response[key];
        });
        return;
      }

      BQData[fields[key]] = response[key];

    });

    log.debug({
      category: 'thirdParty',
      message: 'buildV1MrktBQTrialCreate',
      data: BQData
    });

    return BQData;
  };

  /**
   * Build V1 marketing Biq Query object
   *
   * @param response
   * @returns {{}}
   */
  this.buildV2MrktBQTrialCreate = (response) => {
    const fields = {
      campaign: 'campaign',
      country: 'country',
      createdOn: 'createdOn',
      deviceType: 'deviceType',
      emailAddress: 'email',
      firstName: 'firstName',
      gaClientID: 'gaClientId',
      Geo_City__c: 'geo_city',
      Geo_Continent__c: 'geo_continent',
      Geo_Country__c: 'geo_country',
      Geo_Ip__c: 'geo_ip',
      Geo_Latitude__c: 'geo_latitude',
      Geo_Longitude__c: 'geo_longitude',
      Geo_Postal_Code__c: 'geo_postalCode',
      Geo_State__c: 'geo_state',
      Geo_Time_Zone__c: 'geo_timeZone',
      keyword: 'keyword',
      landingpage: 'landingPage',
      lastName: 'lastName',
      leadDescription: 'leadDescription',
      leadSource: 'leadSource',
      leadTimeSent: 'leadTimeSent',
      medium: 'medium',
      optimizely: 'optimizely',
      phoneNumber: 'phone',
      referrer: 'referrer',
      SMSOptIn: 'SMSOptIn',
      SocialSignUp__c: 'socialSignUp',
      SocialSignUpNetwork__c: 'socialNetwork',
      source: 'source',
      storeName: 'storeName',
      storeUrl: 'storeUrl',
      tenantId: 'tenantId',
      version: 'version'
    };

    const BQData = {};

    Object.keys(response).forEach((key) => {
      if (fields[key] === undefined) {
        return;
      }

      if (Array.isArray(fields[key])) {
        fields[key].forEach((k) => {
          BQData[k] = response[key];
        });
        return;
      }

      BQData[fields[key]] = response[key];
    });

    log.debug({
      category: 'thirdParty',
      message: 'buildV2MrktBQTrialCreate',
      data: BQData
    });

    return BQData;
  };

  /**
   * Send V2 info to warehouse
   *
   * @param response
   * @returns Promise
   */
  this.sendV2MrktBQTrialCreate = (response) => {
    log.debug({
      category: 'thirdParty',
      message: 'sendV2MrktBQTrialCreate'
    });

    const d = this.buildV2MrktBQTrialCreate(response);

    return $http.post(process.env.TRIALS.V2_BQ_CREATE_URL, d);
  };
}];